export const galaxyPadTokenAddress =
  "0x8416848B5A44EEdbd6555FC85e93ddEE51b75A7E";
export const stakingAddress = "0x72E0D83384c6e15d872f1a154666dF9985925036";
export const saleContractAddress = "0x0033E4c840e97b2055bc78af7faB32431E49F201";
export const busdAddress = "0x1933CAFbc5a1840355DBd9967a3e97FF36f14370";
